import { render, staticRenderFns } from "./AddFeatureConfig.vue?vue&type=template&id=3606dedb&"
import script from "./AddFeatureConfig.vue?vue&type=script&lang=js&"
export * from "./AddFeatureConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports